import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ScopeAndSequence from "./routes/ScopeAndSequence";
export default store => ({
  path: "content-skills",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "content-skills" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ScopeAndSequence(store)],
});
